export default __webpack_public_path__ + "static/cheer-b2f494b1b74bb1d5d27559ad3865a2f6.mp3";